export const ACTION = {
    DELETE: 'delete',
    UNDELETE: 'undelete',
    COPY: 'copy',
    UNLINK: 'unlink',
    EDIT: 'edit',
    PREVIEW: 'preview'
}

/**
 * @typedef {
 * 'delete' |
 * 'undelete' |
 * 'copy' |
 * 'unlink' |
 * 'edit' |
 * 'preview'
 * } CalendarAction
 */
